import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HomeHero from "./sections/HomeHero";
import CapabilityBanner from "./sections/CapabilityBanner";
import ExternalPressures from "./sections/ExternalPressures";
import ThreeForces from "./sections/ThreeForces";
import DiscoverySprintCTA from "./sections/DiscoverySprintCTA";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />
      <main className="flex-grow">
        <HomeHero />
        <CapabilityBanner />
        <ExternalPressures />
        <ThreeForces />
        <DiscoverySprintCTA />
      </main>
      <Footer />
    </div>;
}